import { render, staticRenderFns } from "./AnexoLibreria.vue?vue&type=template&id=5b637fae&scoped=true&"
import script from "./AnexoLibreria.vue?vue&type=script&lang=js&"
export * from "./AnexoLibreria.vue?vue&type=script&lang=js&"
import style0 from "./AnexoLibreria.vue?vue&type=style&index=0&id=5b637fae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b637fae",
  null
  
)

export default component.exports